<template>
  <section ref="scrollContainer" :class="['section', 'child-view']">
    <div class="portfolio-container">
      <div class="portfolio-title-area">
        <h1 class="portfolio-page-title">Portfolio</h1>
        <p class="portfolio-page-description">
          We are proud of our projects and the paths we've paved together with our clients.
          Turning every bold idea into a functional and beautiful digital reality is what we do best.
        </p>
      </div>
      <div class="portfolio-grid">
        <router-link
          v-for="item in portfolio"
          :key="item.slug"
          :to="`/portfolio/${item.slug}`"
          class="portfolio-card"
        >
          <div class="portfolio-card-image-box">
            <img
              :src="item.image.path"
              :alt="item.title"
              class="portfolio-card-img"
            />
            <div class="portfolio-card-overlay">
              <h2 class="portfolio-card-title">{{ item.title }}</h2>
              <h3 class="portfolio-card-subtitle">{{ item.description }}</h3>
            </div>
          </div>
        </router-link>
      </div>
      <Footer></Footer>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Footer from '@/components/UI/Footer';

let savedPortfolioScroll = 0;

export default {
  components: {
    Footer,
  },
  computed: {
    ...mapGetters({ portfolio: 'portfolio/portfolio:get' }),
  },
  created() {
    if (this.portfolio.length < 1) {
    this.fetchPortfolio();
  } else {
    this.fetchPortfolio();
  }
  },
  mounted() {
    if (savedPortfolioScroll > 0) {
      this.$nextTick(() => {
        if (this.$refs.scrollContainer) {
          this.$refs.scrollContainer.scrollTop = savedPortfolioScroll;
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!from.path.startsWith('/portfolio/')) {
      savedPortfolioScroll = 0;
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.scrollContainer) {
      savedPortfolioScroll = this.$refs.scrollContainer.scrollTop;
    }
    next();
  },
  methods: {
    ...mapActions({ fetchPortfolio: 'portfolio/portfolio:fetch' }),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Portfolio.vue